export function DataTable({ columns, rows, empty = "Aucun résultat", onRowClick, rowTestIdPrefix = "row" }) {
  if (!rows || rows.length === 0) {
    return (
      <div className="card-empty">
        <div style={{ fontSize: 26, color: "var(--text-3)", marginBottom: 6 }}>
          <i className="fa-regular fa-folder-open"></i>
        </div>
        <div>{empty}</div>
      </div>
    );
  }

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            {columns.map((c, i) => (
              <th key={i} className={c.sortable ? "sortable" : ""} style={c.width ? { width: c.width } : undefined}>
                {c.label}
                {c.sortable ? <i className="fa-solid fa-sort sort-i"></i> : null}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr
              key={r.id || i}
              className={onRowClick ? "row-clickable" : ""}
              data-testid={`${rowTestIdPrefix}-${r.id || i}`}
              onClick={onRowClick ? () => onRowClick(r) : undefined}
            >
              {columns.map((c, ci) => (
                <td key={ci}>{c.render ? c.render(r) : r[c.key] ?? "—"}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
